import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
@Injectable()
export class TargetGroupSettingService {
  constructor (private http: HttpClient, private api: AppConfig) {

  }

  getTargetGroupSettingById(id) {
    return this.http.get(this.api.baseUrl + '/targetGroupSetting/targetGroupSetting?id=' + id , this.api.jsonTokenHeaders);
  }

  addTargetGroupSetting(data) {
    return this.http.post(this.api.baseUrl + '/targetGroupSetting/addTargetGroupSetting' , data , this.api.jsonTokenHeaders);
  }
}
